import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "backdrop", "panel"]

  connect() {
    // Initialize the controller
  }

  showModal() {
    // Show modal container
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    
    // Trigger animations on next frame
    requestAnimationFrame(() => {
      // Fade in backdrop (ease-out duration-300)
      if (this.hasBackdropTarget) {
        this.backdropTarget.style.opacity = "1"
      }
      
      // Animate panel (ease-out duration-300)
      if (this.hasPanelTarget) {
        this.panelTarget.style.opacity = "1"
        this.panelTarget.style.transform = "translateY(0) scale(1)"
      }
    })
  }

  closeModal() {
    // Animate out backdrop (ease-in duration-200)
    if (this.hasBackdropTarget) {
      this.backdropTarget.style.transition = "opacity ease-in duration-200"
      this.backdropTarget.style.opacity = "0"
    }
    
    // Animate out panel (ease-in duration-200)
    if (this.hasPanelTarget) {
      this.panelTarget.style.transition = "all ease-in duration-200"
      this.panelTarget.style.opacity = "0"
      this.panelTarget.style.transform = "translateY(4px) scale(0.95)"
    }
    
    // Hide modal after animation completes
    setTimeout(() => {
      this.modalTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
      
      // Reset styles for next open
      if (this.hasBackdropTarget) {
        this.backdropTarget.style.transition = ""
        this.backdropTarget.style.opacity = ""
      }
      if (this.hasPanelTarget) {
        this.panelTarget.style.transition = ""
        this.panelTarget.style.opacity = ""
        this.panelTarget.style.transform = ""
      }
    }, 200)
  }

  // Close modal when clicking outside (on backdrop)
  clickOutside(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }

  // Close modal with Escape key
  keydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }


} 